import React from "react";
import { Navigate } from "react-router-dom";
import constants from "../utils/contants";

const PrivateRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem(constants.TOKEN);

  if (isAuthenticated) {
    return children;
  }

  return <Navigate to="/login" />;
};

export default PrivateRoute;
